<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加角色信息按钮 -->
      <el-row>
        <el-col>
          <el-button type="primary" size="mini" icon="el-icon-plus" plain @click="addDialogVisible = true" class="btn1">新增</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 商品信息表格 -->
        <el-table :data="roleList">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="角色名称" prop="RoleName" align="center"></el-table-column>
          <el-table-column label="角色编号" prop="RoleNO" align="center"></el-table-column>
          <el-table-column label="备注" prop="Remark" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text"  icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
              <el-button type="text" icon="el-icon-delete" size="mini" @click="removeRole(scope)">删除</el-button>
              <el-button type="text" icon="el-icon-menu" size="mini" @click="getRoleMenu(scope);">关联菜单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-drawer
        title="当前角色已有菜单"
        :visible.sync="table"
        direction="rtl"
        size="50%">

        <div>
          <el-button type="primary" size="mini" @click="getMenuNo() ;innerDrawer=true" style="margin-left: 16px;">
            关联菜单
        </el-button>
            <el-drawer
              title="请选择菜单，在关联时最上级会自动关联"
              :append-to-body="true"

              :visible.sync="innerDrawer">
              <el-table
                ref="multipleTable"
                :data="MenuData"
                tooltip-effect="dark"
                style="width: 100%"
             >
             <el-table-column property="ID" label="编号" width="100" align="center"></el-table-column>
            <el-table-column property="MenuName" label="菜单名称" width="100" align="center"></el-table-column>
            <el-table-column property="ParentID" label="父编号" width="100" align="center"></el-table-column>
            <el-table-column property="ParentName" label="父菜单" width="100" align="center"></el-table-column>
            <el-table-column property="path" label="路径" width="100" align="center"></el-table-column>
            <el-table-column width="100" label="操作" align="center">
              <template slot-scope="scope2">
                 <el-button type="text" size="100" @click="addMenu(scope2)">关联</el-button>
              </template>
                </el-table-column>

              </el-table>

            </el-drawer>
            </div>
        <el-table :data="gridData">
          <el-table-column property="ID" label="关联ID" width="150" align="center"></el-table-column>
            <el-table-column property="MenuName" label="菜单名" width="150" align="center"></el-table-column>
            <el-table-column property="MenuID" label="菜单ID" width="100" align="center"></el-table-column>
            <el-table-column property="ParentName" label="父菜单" width="150" align="center"></el-table-column>
            <el-table-column property="RoleName" label="所属角色" width="150" align="center"></el-table-column>
            <el-table-column property="RoleID" label="角色ID" width="100" align="center"></el-table-column>
            <el-table-column width="100" label="操作" align="center">
              <template slot-scope="scope1">
                <el-button type="text" size="mini"  @click="deleteMenu(scope1)">解除关联</el-button>
              </template>

            </el-table-column>

            </el-table>
      </el-drawer>



      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15, 50]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>

    <!-- 添加角色信息的对话框 -->
    <el-dialog title="添加角色信息" :visible.sync="addDialogVisible" width="25%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm"  ref="addFormRef" label-width="90px">
        <el-form-item label="角色名" prop="RoleName" required>
          <el-input v-model="addForm.RoleName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="角色编号" prop="RoleNO" required>
          <el-input v-model="addForm.RoleNO" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="addForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="addDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="addRole()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑角色信息的会话框 -->
    <el-dialog title="修改角色信息" :visible.sync="editDialogVisible" width="25%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="80px">
        <el-form-item label="角色名" prop="RoleName">
          <el-input v-model="editForm.RoleName"></el-input>
        </el-form-item>
        <el-form-item label="角色编号" prop="RoleNO">
          <el-input v-model="editForm.RoleNO"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editRole">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: 1,
                limit: 5,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_role'
            },
            getTypeList1: {
                page: 1,
                limit: '10000',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            getTypeList2: {
                page: 1,
                limit: '10000',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                ID:'',
                RoleName:''

            },
            innerDrawer: false,
            // 角色信息表
            roleList: [],
            // 仓库信息表
            warehouselist: [],
            // 产品信息表
            productSetingList: [],
            // 添加用户的表单数据
            addForm: {
                RoleName: '',
                RoleNO: '',
                Remark: ''
            },
            MenuData:[],
            // 数据总条数
            total: 0,
            //控制添加表单的显示与隐藏
            addDialogVisible: false,
            //控制修改表单的显示与隐藏
            editDialogVisible: false,
            // 编辑信息的表单数据
            editForm: {},
            // 修改表单的验证规则对象
            editFormRules: {
                StorageLocationNO: [
                    { required: true, message: '请输入储位编号', trigger: 'blur' },
                ],
                WarehouseSet_ID: [
                    { required: true, message: '请输入仓库管理标识符', trigger: 'blur' },
                ],
                Main_ProductSet_ID: [
                    { required: true, message: '请输入产品设置标识符', trigger: 'blur' },
                ],
                QTY: [
                    { required: true, message: '请输入产品数量', trigger: 'blur' },
                ],
            },
            table: false,
            loding: false,
            gridData: [],
            MenuData:[],

        }
    },
    created () {
        this.getRoleList()
        this.getRoleList1()

    },
    methods: {
      async   addMenu(scope){
        let params = new URLSearchParams();
        params.append("MenuName",scope.row.MenuName)
        params.append("ParentName",scope.row.ParentName)
        params.append("ParentID",scope.row.ParentID)
        params.append("MenuID",scope.row.ID)
        params.append("privateKey", this.getTypeList.privateKey)
        params.append("appIdentification", this.getTypeList.appIdentification)
        params.append("RoleID",  this.getTypeList2.ID)
        params.append("RoleName",  this.getTypeList2.RoleName)
        const { data: res } = await this.$http.post('/User/addMenuRole', params)
            console.log(res)
            if (res.code== 1) {
              this.getMenuNo()
              this.getRoleMenuONE()
              return this.$message.success('关联成功')

                }else{
                  return this.$message.error('关联失败')
                }
      },
          async getRoleMenuONE () {

            const { data: res } = await this.$http.get('/User/getMenuRole', { params: this.getTypeList2 })

            this.gridData = res.data
        },
      async deleteMenu(scope1){
        let params = new URLSearchParams();

            params.append("ID", scope1.row.ID)
            params.append("MenuID",scope1.row.MenuID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("RoleID", scope1.row.RoleID)

            const { data: res } = await this.$http.post('/User/deleteMenuRole', params)

            if (res.code== 1) {
              this.getRoleMenuONE()
              return this.$message.success('删除成功')
                }else{
                  return this.$message.error('删除失败')
                }

      }
      ,
        async getMenuNo(){

          const { data: res } = await this.$http.get('/User/SelectRoleMenuNo', { params: this.getTypeList2 })

            this.MenuData = res.data
        },
        // 调用接口获取角色信息
        async getRoleList () {
            const { data: res } = await this.$http.get('/User/RoleAll', { params: this.getTypeList })

            this.roleList = res.data
        },
        async getRoleList1 () {
            const { data: res } = await this.$http.get('/User/RoleAll', { params: this.getTypeList1 })
            this.total = res.data.length
        },
        async getRoleMenu (scope) {

          this.table = true
          this.getTypeList2.ID=scope.row.ID;
          this.getTypeList2.RoleName=scope.row.RoleName;
            const { data: res } = await this.$http.get('/User/getMenuRole', { params: this.getTypeList2 })

            this.gridData = res.data
        },
        // 调用接口删除角色信息
        async removeRole (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该信息, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/User/DeleteRole', params)
            console.log(res)
            if (res.code !== 1) {
                return this.$message.error('删除失败！')
            }else{
              this.$message.success('删除成功！')
            }
            this.getRoleList()
            this.getRoleList1()

        },
        //  监听添加信息对话框的关闭事件
        addDialogClosed () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口添加角色信息
        addRole () {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("RoleName", this.addForm.RoleName)
                 params.append("RoleNO", this.addForm.RoleNO)
                params.append("Remark", this.addForm.Remark)
                const { data: res } = await this.$http.post('/User/InsertRole', params)
                console.log(res.data)
                // if (res == -3) {
                //     return this.$message.error('添加失败，储位重复！')
                // }
                // this.$message.success('添加仓库储位信息成功！')
                // 隐藏添加信息的对话框
                this.addDialogVisible = false
                // 重新获取仓库储位信息列表数据
                this.getRoleList()
                this.getRoleList1()
            })
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        // 展示修改角色信息的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.getTypeList.tableName)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.editForm = res.data[0]
        },
        // 调用接口编辑角色信息
        editRole () {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                 params.append("ID", this.editForm.ID)
                params.append("RoleName", this.editForm.RoleName)
                params.append("RoleNO", this.editForm.RoleNO)
                params.append("Remark", this.editForm.Remark)
                console.log('123'+params)
                const { data: res } = await this.$http.post('/User/UpdateRole', params)
                console.log(res)
                if (res !== 1) {
                    return this.$message.error('更新角色信息失败！')
                }else{
                  this.$message.success('更新角色信息成功！')
                }
                // 关闭对话框
                this.editDialogVisible = false
                // 刷新数据列表
                this.getRoleList()
                this.getRoleList1()
            })
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getRoleList()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.getTypeList.page = newPage
            this.getRoleList()
        },
    }
}
</script>

<style lang="less" scoped>
.btn1 {
  margin-bottom: 10px;
}
</style>

